import { Flex, Link, Text } from "@/atoms"
import { getLinkByVulnerability } from "@/domain/vulnerability"
import {
  DEFAULT_FORMAT,
  getDateFromSeconds,
  getDateInUserLocale
} from "@/helpers/date.helpers"
import { preventEventBubbling } from "@/helpers/utils"
import { VulnerabilityProviderIcon } from "@/icons"

import type { RiskTooltipDescriptionProps } from "."

import styles from "./RiskTooltip.module.scss"

export const RiskTooltipDescription: React.FC<RiskTooltipDescriptionProps> = (
  props
) => {
  const { riskId, publishedOn, noPublishedOn } = props
  const link = getLinkByVulnerability({ cve: riskId }) || ""
  const formattedPublishDate = publishedOn
    ? getDateInUserLocale(getDateFromSeconds(publishedOn), DEFAULT_FORMAT)
    : "-"
  const cve = riskId || "-"
  const Component = link ? Link : Text
  const propsComponent = link
    ? {
        href: link,
        target: "_blank",
        onClick: (e: Event | React.SyntheticEvent) => {
          preventEventBubbling(e)
          props.onExternalLinkClick?.(riskId, link)
        }
      }
    : {}

  return (
    <Flex gap={24} align="flex-start" justify="space-between">
      <Flex vertical>
        <Component className={styles.title} {...propsComponent}>
          {cve}
        </Component>
        {!noPublishedOn && (
          <Text className={styles.date}>{formattedPublishDate}</Text>
        )}
      </Flex>
      <VulnerabilityProviderIcon
        expanded
        riskId={riskId}
        className={styles.provider}
      />
    </Flex>
  )
}
